import React from "react";
import ToastWrapper from "./toast.style";
import classNames from "classnames";

/** Prevent toast messages from crashing the whole CMS (blank white page). */
const toSafeToastText = value => {
  if (value == null || value === false) return "";
  if (typeof value === "string" || typeof value === "number")
    return String(value);
  if (React.isValidElement(value)) return value;
  if (typeof value === "object") {
    if (typeof value.message === "string") return value.message;
    try {
      return JSON.stringify(value);
    } catch (e) {
      return "Something went wrong.";
    }
  }
  return String(value);
};

const CustomToast = props => {
  const {
    message,
    heading,
    className,
    style,
    width,
    position = "",
    show,
    transition = false
  } = props;

  const safeMessage = toSafeToastText(message);
  const safeHeading = toSafeToastText(heading);

  return (
    <ToastWrapper width={width}>
      {show && (
        <div
          className={classNames(
            className,
            "custom-toast",
            transition && position.substring(0, 3) === "top" && "animated",
            transition && position.substring(0, 3) === "top" && "fadeInDown",
            transition && position.substring(0, 6) === "bottom" && "animated",
            transition && position.substring(0, 6) === "bottom" && "fadeInUp",
            position
          )}
          style={style}
        >
          <div>
            <i className="fas fa-bell mr-8" />
            <strong className="mr-auto">{safeHeading}</strong>
            <i
              className="far fa-times-circle close-icon"
              onClick={() => props.onCloseCLick && props.onCloseCLick()}
            />
          </div>
          <div>{safeMessage}</div>
        </div>
      )}
    </ToastWrapper>
  );
};

export default CustomToast;
